import { Component, OnDestroy, OnInit } from '@angular/core'
import { Ng2DeviceService } from 'ng2-device-detector'
import { fuseAnimations } from '../../../core/animations'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { FuseConfigService } from '../../../core/services/config.service'
import { AuthService } from '../../../auth.service'
import { Router, ActivatedRoute } from '@angular/router'
import { FuseTranslationLoaderService } from '../../../core/services/translation-loader.service'
import { loginDutch } from './i18n/nl'
import { DeviceService } from '../service/device.service'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/do'
import { ProfileService } from '../../services/profile.service'
import { Observable } from 'rxjs/Observable'
import { Subscription } from 'rxjs/Subscription'
import { HttpErrorResponse } from '@angular/common/http'

@Component({
  selector: 'fuse-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: fuseAnimations,
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm: FormGroup
  loginFormErrors: any
  returnUrl: string
  deviceInfo: any
  doLogin: Subscription
  doGetToken: Subscription
  isLoading = false
  visibleMessage: string
  onTokenCheck = false

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fuseConfig: FuseConfigService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private translationLoader: FuseTranslationLoaderService,
    private deviceService: Ng2DeviceService,
    private device: DeviceService,
    private profileService: ProfileService,
  ) {
    this.translationLoader.loadTranslations(loginDutch)

    this.fuseConfig.setSettings({
      layout: {
        navigation: 'none',
        toolbar: 'none',
        footer: 'none',
      },
    })

    this.loginFormErrors = {
      email: {},
      password: {},
      login: {},
    }
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['token']) {
        this.checkMagicToken(params['token'])
      }
    })

    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    })

    this.returnUrl = localStorage.getItem('redirect') || '/administrations'
  }

  private checkMagicToken(magicToken: string): void {
    this.onTokenCheck = true

    this.authService
      .verifyMagicLinkAndRefresh(magicToken)
      .do(() => (this.isLoading = false))
      .do(() => (this.loginFormErrors.login.failed = false))
      .switchMap(() => {
        return this.profileService.get()
      })
      .switchMap(profile => {
        this.profileService.storeProfile(profile)
        return Observable.of(profile)
      })
      .switchMap(profile => {
        this.deviceInfo = this.device.getDevice(this.deviceService.getDeviceInfo())
        return this.device.registerDevice(this.deviceInfo)
      })
      .subscribe(
        response => {
          this.isLoading = false
          if (response.active === false) {
            this.device.activateDevice(this.deviceInfo.device_id).subscribe()
            this.router.navigate(['2fa'])
          } else {
            this.authService
              .twoFactor(this.deviceInfo)
              .do(token => {
                this.authService.onLoggedIn(token)
              })
              .subscribe()

            this.router.navigateByUrl(this.returnUrl)
          }

          return Observable.of(response)
        },
        error => {
          this.isLoading = false
          this.loginFormErrors.login.failed = true
          this.router.navigate(['/login'])
        },
      )
  }

  getMagicLink(): void {
    this.isLoading = true
    this.visibleMessage = 'LOGIN.SENDING_MAGIC_LINK'
    this.doGetToken = this.authService
      .getMagicToken(this.loginForm.get('email').value)
      .map((res: {}) => {
        this.isLoading = false
        this.visibleMessage = 'LOGIN.SENT_MAGIC_LINK'
        return Observable.of(res)
      })
      .catch((err: HttpErrorResponse) => {
        this.isLoading = false
        this.visibleMessage = null
        this.loginFormErrors.login.failed = true
        return Observable.throw(err)
      })
      .subscribe()
  }

  ngOnDestroy(): void {
    if (this.doLogin) {
      this.doLogin.unsubscribe()
    }

    if (this.doGetToken) {
      this.doGetToken.unsubscribe()
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/authentication/login/login.component.ts